// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"461":"af232888","540":"77dd3818","787":"d1ea5dd3"}[chunkId] + ".chunk.js";
};